import { render, staticRenderFns } from "./ConvenioPlanoTrabalho.vue?vue&type=template&id=48e71126"
import script from "./ConvenioPlanoTrabalho.vue?vue&type=script&lang=js"
export * from "./ConvenioPlanoTrabalho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports